import { useMemo } from 'react';

import { prepareDataForStackedChart } from '../helpers/dataTransformHelpers';
import { ChartIssuesInput } from '../types';

type ChartPattern = {
	id: string;
	label: string;
	color: string;
};

interface ChartDataResult {
	chartData: Array<{
		date: string;
		critical: number;
		serious: number;
		total: number;
	}>;
	patterns: ChartPattern[];
	categories: string[];
}

export const useChartData = (
	data?: ChartIssuesInput,
	uniqueIssuesData?: ChartIssuesInput,
	showUnique?: boolean
): ChartDataResult => {
	return useMemo(() => {
		if (showUnique && uniqueIssuesData) {
			if (!uniqueIssuesData || uniqueIssuesData.length === 0) {
				return { chartData: [], patterns: [], categories: [] };
			}
			const result = prepareDataForStackedChart(uniqueIssuesData);
			const categories = result.chartData.map((item) => item.date);
			return { ...result, categories };
		}

		if (!data?.length) {
			return { chartData: [], patterns: [], categories: [] };
		}

		const result = prepareDataForStackedChart(data);
		const categories = result.chartData.map((item) => item.date);
		return { ...result, categories };
	}, [data, uniqueIssuesData, showUnique]);
};
